/**
 * <s-reviews-slider>: turns the review list inside it into a sideways slider.
 * Buttons with [data-reviews-prev] / [data-reviews-next] scroll the track
 * (the element matching data-track) by one card; they disable at either end.
 */
class SReviewsSlider extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector(this.dataset.track || '.jdgm-rev-widg__reviews');
    this.prev = this.querySelector('[data-reviews-prev]');
    this.next = this.querySelector('[data-reviews-next]');
    if (!this.track || !this.prev || !this.next) return;

    this.onPrev = () => this.scrollByCard(-1);
    this.onNext = () => this.scrollByCard(1);
    this.onScroll = () => this.update();
    this.prev.addEventListener('click', this.onPrev);
    this.next.addEventListener('click', this.onNext);
    this.track.addEventListener('scroll', this.onScroll, { passive: true });
    this.resizeObserver = new ResizeObserver(() => this.update());
    this.resizeObserver.observe(this.track);
    this.update();
  }

  disconnectedCallback() {
    this.prev?.removeEventListener('click', this.onPrev);
    this.next?.removeEventListener('click', this.onNext);
    this.track?.removeEventListener('scroll', this.onScroll);
    this.resizeObserver?.disconnect();
  }

  scrollByCard(direction) {
    const card = this.track.firstElementChild;
    const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
    const step = card ? card.getBoundingClientRect().width + gap : this.track.clientWidth;
    const rtl = getComputedStyle(this).direction === 'rtl' ? -1 : 1;
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    this.track.scrollBy({ left: step * direction * rtl, behavior: reduce ? 'auto' : 'smooth' });
  }

  update() {
    const max = this.track.scrollWidth - this.track.clientWidth;
    const pos = Math.abs(this.track.scrollLeft);
    const scrollable = max > 1;
    this.prev.hidden = !scrollable;
    this.next.hidden = !scrollable;
    this.prev.disabled = pos <= 1;
    this.next.disabled = pos >= max - 1;
  }
}

if (!customElements.get('s-reviews-slider')) customElements.define('s-reviews-slider', SReviewsSlider);
